import {
  StoreModel,
  StoreModelDate,
  StoreModelType,
} from '@aksia/infrastructure';
import { IShareClass } from '../../interfaces/shareclass/shareclass.interface';
import { DataSourceEnum } from '../../enums/entity.enum';

export abstract class ShareClass extends StoreModel implements IShareClass {
  classId?: number;
  fundId?: number;
  className?: string;
  isDefault?: boolean;
  isDeleted?: boolean;
  noLongerOffered?: boolean;

  source: DataSourceEnum | undefined = undefined;

  @StoreModelType(() => StoreModelDate)
  asOfDate: Date | undefined = undefined;
}
export interface ShareClass extends IShareClass {}
